const endpoints = {
  access: {
    changePassword: 'access/password/',
    getToken: 'access/asktoken/',
    login: 'access/login/',
    csrf: 'access/csrf/',
  },
};

export default endpoints;
